// r24 — /translate/naati/city/$slug (77 TH provinces)
import { createFileRoute, notFound } from "@tanstack/react-router";
import NaatiThProvinceRenderer from "@/components/NaatiThProvinceRenderer";
import { getNaatiProvince } from "@/data/naati-th-provinces";
import { canonicalAndHreflang, ctaDesc, ctaTitle } from "@/lib/seo";

const SITE = "https://nyclanguageinstitute.com";

export const Route = createFileRoute("/translate/naati/city/$slug")({
  loader: ({ params }) => {
    const p = getNaatiProvince(params.slug);
    if (!p) throw notFound();
    return { province: p };
  },
  head: ({ params }) => {
    const p = getNaatiProvince(params.slug);
    if (!p) return { meta: [{ title: ctaTitle("Not found", "/translate/naati/city/$slug", "th")}, { name: "robots", content: "noindex" }] };
    const url = `${SITE}/translate/naati/city/${p.slug}`;
    const title = `แปล NAATI ${p.th} — รับเอกสารถึงบ้าน 3 วันทำการ | NYC`;
    const desc = `บริการแปล NAATI สำหรับลูกค้าใน${p.th} — DHL Domestic 1–2 วันทำการ ครอบคลุมวีซ่าออสเตรเลียทุกประเภท /หน้า — ส่งภาพเอกสารให้เราตรวจก่อน ฟรี`;
    return {
      meta: [
        { title: ctaTitle(title, "/translate/naati/city/$slug", "th") }, { name: "description", content: ctaDesc(desc, "/translate/naati/city/$slug", "th")},
        { property: "og:title", content: ctaTitle(title, "/translate/naati/city/$slug", "th")}, { property: "og:description", content: ctaDesc(desc, "/translate/naati/city/$slug", "th")},
        { property: "og:url", content: url }, { property: "og:locale", content: "th_TH" },
      ],
      links: canonicalAndHreflang(`/translate/naati/city/${p.slug}`, `/en/translate/naati/city/${p.slug}`),
      scripts: [
        { type: "application/ld+json", children: JSON.stringify({
          "@context": "https://schema.org", "@type": "Service", inLanguage: "th",
          name: `NAATI Translation ${p.th}`,
          areaServed: { "@type": "AdministrativeArea", name: p.en, address: { "@type": "PostalAddress", addressRegion: p.regionEn, addressCountry: "TH" } },
          provider: { "@type": "Organization", name: "NYC Language Institute", url: SITE }, url,
        }) },
      ],
    };
  },
  component: () => {
    const { province } = Route.useLoaderData();
    return <NaatiThProvinceRenderer locale="th" province={province} />;
  },
});
